import Logo from "./Logo";
import illustrationJpg from '../img/MyRopo_Hero.jpg';
import illustrationAvif from '../img/MyRopo_Hero.avif';
import LocaleDropdownSelector from "./LocaleDropdownSelector";
import PropTypes from "prop-types";
import useEnv from "../hooks/useEnv";
import React from "react";
import AlertDialog from "./AlertDialog";
import { CUSTOMERTYPE } from "../contexts/AuthContext";

const LandingTop = ({ locale, alert, onSignIn }) => {
    const { isEnvTruthy, getEnv } = useEnv();
    const newsLink = getEnv('NEWS_LINK_URL');

    const signInButtonsElement = <>
        <button
            className="btn btn-personal-sign-in"
            onClick={() => onSignIn(CUSTOMERTYPE.PERSON)}
            aria-label={locale.personalSignInButton}
        >
            {locale.personalSignInButton}
        </button>
        {isEnvTruthy('COMPANY_TOGGLE') && (
            <button
                className="btn btn-company-sign-in"
                onClick={() => onSignIn(CUSTOMERTYPE.COMPANY)}
                aria-label={locale.companySignInButton}
            >
                {locale.companySignInButton}
            </button>
        )}
    </>

    const parseLinkText = (txt) => {
        const matches = txt.match(/%.+%/gm);
        if (newsLink === undefined || newsLink === null || newsLink === '') {
            return null;
        }
        if (!matches || matches.length < 1) {
            return txt;
        }
        const match = matches[0];
        const parts = txt.split(match);
        const elements = [];
        for (let i = 0; i < parts.length; i++) {
            elements.push(<span key={`text-${i}`}>{parts[i]}</span>);
            if (i === 0) {
                elements.push(
                    <a
                        key={`link-${i}`}
                        className='landing-page-news-link'
                        href={newsLink}
                        target='_blank'
                        aria-label={locale.linkAriaLabel}
                    >
                        {match.substring(1, match.length - 1)}
                    </a>
                );
            }
        }
        return elements;
    }

    return (
        <div className='landing-element-container' id="landing-page-top">
            <div className='landing-element-content'>
                <div className='d-flex justify-content-between align-items-center mb-3 mb-sm-5'>
                    <Logo color='white' width={124} height={40} ariaLabel='MyRopo logo' />
                    <div>
                        <LocaleDropdownSelector hideChevron />
                    </div>
                </div>
                {alert !== null && alert.message !== undefined && (
                    <AlertDialog
                        message={alert.message}
                        type={alert.type}
                    />
                )}
                <div className='row'>
                    <div className='col-md-6'>
                        <h1>{locale.title}</h1>
                        <p>{locale.subtitle}</p>
                        <p>{parseLinkText(locale.linkText)}</p>
                        <div className='flex-column gap-2 mt-4 me-lg-5 d-none d-md-flex' id='desktop-sign-in-buttons'>
                            {signInButtonsElement}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <picture>
                            <source srcSet={illustrationAvif} type="image/avif" />
                            <img src={illustrationJpg} aria-hidden className='landing-hero' alt='Hero' />
                        </picture>
                        <div className='d-flex flex-column gap-2 mt-4 me-md-5 d-md-none' id='mobile-sign-in-buttons'>
                            {signInButtonsElement}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

LandingTop.propTypes = {
    locale: PropTypes.object.isRequired,
    alert: PropTypes.object,
    onSignIn: PropTypes.func.isRequired
}

export default LandingTop;
